import { getIsThirdPartyCallingPopoverInUse, getIsTwilioBasedCallProvider } from 'calling-internal-common/utils/isThirdPartyCallingPopoverInUse';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { getIn } from '../../utils/getIn';
import { ThirdPartyHelpDeskPopover } from '../components/ThirdPartyHelpDeskPopover';
import { useCalleeDetails } from './useCalleeDetails';
import { getPersistedCallProvider } from 'calling-lifecycle-internal/utils/getLocalCallSettings';
import CallingProvider from 'calling-internal-common/call-provider/records/CallingProvider';
import { useWorkerBroadcastEventHandler } from 'calling-ui-library/hooks/useWorkerBroadcastEventHandler';
import { isSucceeded } from '../../async-data/operators/statusComparators';
import { jsx as _jsx } from "react/jsx-runtime";
export const useThirdPartyNumbersPopover = props => {
  const {
    appIdentifier,
    subjectId,
    objectTypeId,
    threadId,
    auth
  } = props;
  const gates = getIn(['gates'], auth);
  const {
    data: calleeOmnibusResult,
    status: calleeOmnibusStatus
  } = useCalleeDetails(Number(subjectId), objectTypeId);
  const [selectedCallProvider, setSelectedCallProvider] = useState(getPersistedCallProvider());
  const [isThirdPartyCallingPopoverInUse, setIsThirdPartyCallingPopoverInUse] = useState(false);
  useEffect(() => {
    setIsThirdPartyCallingPopoverInUse(isSucceeded(calleeOmnibusStatus) && selectedCallProvider ? getIsThirdPartyCallingPopoverInUse(gates || [], selectedCallProvider) : false);
  }, [selectedCallProvider, gates, calleeOmnibusStatus]);
  const handleUpdateCallProvider = useCallback(message => {
    const callingProviderRecord = new CallingProvider(message.payload);
    const isTwilioBasedCallProvider = getIsTwilioBasedCallProvider(callingProviderRecord);
    setSelectedCallProvider(callingProviderRecord);
    setIsThirdPartyCallingPopoverInUse(!isTwilioBasedCallProvider);
  }, []);
  useWorkerBroadcastEventHandler({
    onUpdateCallProviderMessage: handleUpdateCallProvider
  });
  const renderedThirdPartyNumbersPopover = useMemo(() => {
    const {
      inboxId,
      visitorPhoneNumber,
      isKnownVisitor
    } = props;
    return /*#__PURE__*/_jsx(ThirdPartyHelpDeskPopover, {
      appIdentifier: appIdentifier,
      "data-test-id": "third-party-numbers-popover",
      inboxId: inboxId,
      objectTypeId: objectTypeId,
      subjectId: subjectId,
      visitorPhoneNumber: visitorPhoneNumber,
      isKnownVisitor: isKnownVisitor,
      calleeOmnibusResult: calleeOmnibusResult,
      calleeOmnibusStatus: calleeOmnibusStatus,
      selectedCallProvider: selectedCallProvider,
      threadId: threadId,
      gates: gates
    });
  }, [appIdentifier, calleeOmnibusResult, calleeOmnibusStatus, objectTypeId, props, selectedCallProvider, subjectId, threadId, gates]);
  return {
    renderedThirdPartyNumbersPopover,
    isThirdPartyCallingPopoverInUse
  };
};